import React, {} from 'react';
import {connect} from "react-redux";
import {SIDEBAR_HIDDEN_BUTTONS} from "../../../../../constants";
import {toggleChangeLayoutPopup} from "../../../../../../../actions/sqftFunctions";
import NavMiteredSection from "./toolMitered/navMiteredSection";

const SqftNavMitered = (props) => {
  const {underlaymentSections, menuOpened} = props;
  const expanded = menuOpened === SIDEBAR_HIDDEN_BUTTONS.toolUnderlayment && underlaymentSections.length > 0;
  const sectionName = 'Underlayment Section'

  return (
    <div className={"layouts side" + (expanded ? " expanded" : "")} >
      <div className="mitered-sections">
        {
          underlaymentSections.map((underlaymentSection, index) => {
            if (!underlaymentSection) {
              return
            }
            return <NavMiteredSection sectionName={sectionName} miteredSection={underlaymentSection} index={index} key={index}/>
          })
        }
      </div>
    </div>
  )
};

const mapStateToProps = (store) => {
  return {
    menuOpened: store.sqftMenuState.menuOpened,
    underlaymentSections: store.sqftResourceState.underlaymentSections
  };
};

const mapDispatchToProps = {
  toggleChangeLayoutPopup
};


export default connect(mapStateToProps, mapDispatchToProps)(SqftNavMitered);
